import { TranslateModule } from '../../shared/translate/translate.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SettingsComponent } from './settings.component';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [SettingsComponent],
  imports: [
    CommonModule, TranslateModule, IonicModule,
    FormsModule,
  ],
  exports: [
    SettingsComponent
  ]
})
export class SettingsModule { }
